import styled from "styled-components";
interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  .container_rich-text {
    .ant-form-item-row {
      height: 100%;
      .ant-form-item-control-input {
        height: 100%;
        .ant-form-item-control-input-content {
          .ql-container {
            height: unset;
          }
          .ql-editor {
            overflow: hidden;
            padding: 5px 5px;
          }
        }
      }
    }
    .ql-tooltip {
      z-index: 10;
    }
  }
`;
